export default __webpack_public_path__ + "static/media/deepwounds.ea089919.png";